// extracted by mini-css-extract-plugin
module.exports = {"title":"title__17so2","icon":"icon__3RZzk"};